import 'app/styles/index.scss';
import { createRoutesView } from 'atomic-router-react';
import compose from 'compose-function';
import { AccountPage } from 'pages/account-page';
import { AccountsPage } from 'pages/accounts-page';
import { AccountsReportPage } from 'pages/accounts-report-page';
import { AdminLayout } from 'pages/admin-layout';
import { BonusesPage } from 'pages/bonuses-page';
import { CashdeskPage } from 'pages/cashdesk-page';
import { CashdesksPage } from 'pages/cashdesks-page';
import { CashierLayout } from 'pages/cashier-layout';
import { DailyReportPage } from 'pages/daily-report-page';
import { DetailedReportPage } from 'pages/detailed-report-page';
import { DevicesReportPage } from 'pages/devices-report-page';
import { GamePage } from 'pages/game-page';
import { GameSettingsPage } from 'pages/game-settings-page';
import { GamesPage } from 'pages/games-page';
import { JackpotsPage } from 'pages/jackpots-page';
import { LoginPage } from 'pages/login-page';
import { ReviewReportPage } from 'pages/review-report-page';
import { SessionsReportPage } from 'pages/sessions-report-page';
import { ShiftsPage } from 'pages/shifts-page';
import { ShiftsReportPage } from 'pages/shifts-report-page';
import { UserPage } from 'pages/user-page';
import { UsersPage } from 'pages/users-page';
import { shiftModel } from 'entities/shift';
import {
	authorizedAccountRoute,
	authorizedAccountsReportRoute,
	authorizedAccountsRoute,
	authorizedBonusesRoute,
	authorizedCashdeskRoute,
	authorizedCashdesksRoute,
	authorizedDailyReportRoute,
	authorizedDetailedReportRoute,
	authorizedDevicesReportRoute,
	authorizedGameSettingsRoute,
	authorizedGamesRoute,
	authorizedJackpotsRoute,
	authorizedLoginRoute,
	authorizedReviewReportRoute,
	authorizedSessionsReportRoute,
	authorizedShiftsReportRoute,
	authorizedShiftsRoute,
	authorizedUserRoute,
	authorizedUsersRoute,
} from 'shared/routing';
import { PageLoader } from 'shared/ui';
import { withRouter, withTheme, withTranslations } from './providers';

const withProviders = compose(withTranslations, withRouter, withTheme);

const RoutesView = createRoutesView({
	routes: [
		{
			route: authorizedLoginRoute,
			view: LoginPage,
		},
		{
			route: authorizedAccountsRoute,
			view: AccountsPage,
			layout: AdminLayout,
		},
		{
			route: authorizedAccountRoute,
			view: AccountPage,
			layout: AdminLayout,
		},
		{
			route: authorizedCashdesksRoute,
			view: CashdesksPage,
			layout: AdminLayout,
		},
		{
			route: authorizedCashdeskRoute,
			view: CashdeskPage,
			layout: AdminLayout,
		},
		{
			route: authorizedUsersRoute,
			view: UsersPage,
			layout: AdminLayout,
		},
		{
			route: authorizedUserRoute,
			view: UserPage,
			layout: AdminLayout,
		},
		{
			route: authorizedGamesRoute,
			view: GamesPage,
			layout: AdminLayout,
		},
		{
			route: authorizedGameSettingsRoute,
			view: GameSettingsPage,
			layout: AdminLayout,
		},
		{
			route: authorizedReviewReportRoute,
			view: ReviewReportPage,
			layout: AdminLayout,
		},
		{
			route: authorizedDailyReportRoute,
			view: DailyReportPage,
			layout: AdminLayout,
		},
		{
			route: authorizedDetailedReportRoute,
			view: DetailedReportPage,
			layout: AdminLayout,
		},
		{
			route: authorizedAccountsReportRoute,
			view: AccountsReportPage,
			layout: AdminLayout,
		},
		{
			route: authorizedSessionsReportRoute,
			view: SessionsReportPage,
			layout: AdminLayout,
		},
		{
			route: authorizedShiftsReportRoute,
			view: ShiftsReportPage,
			layout: AdminLayout,
		},
		{
			route: authorizedDevicesReportRoute,
			view: DevicesReportPage,
			layout: AdminLayout,
		},
		{
			route: authorizedJackpotsRoute,
			view: JackpotsPage,
			layout: AdminLayout,
		},
		{
			route: authorizedBonusesRoute,
			view: BonusesPage,
			layout: AdminLayout,
		},
		{
			route: authorizedShiftsRoute,
			view: ShiftsPage,
			layout: CashierLayout,
		},
		{
			route: shiftModel.activatedGameRoute,
			view: GamePage,
			layout: CashierLayout,
		},
	],
});

export const App = withProviders(() => (
	<>
		<PageLoader />
		<RoutesView />
	</>
));
